import { EndpointContract } from '@ublend-npm/aula-schema';
import { HOME_SPACES_ENGAGEMENT } from '../../constants/endpoints';
import { HomeSpaceEngagementApiItem } from '../../types/state';
import request from '../request';

export type GetHomeSpacesEngagementResponse = {
  spaceEngagement: HomeSpaceEngagementApiItem[];
};

type GetHomeSpacesEngagementContract = EndpointContract & {
  query: {
    spaceIds?: string;
  };
  responseBody: GetHomeSpacesEngagementResponse;
};

const getHomeSpacesEngagement = async (
  spaceIds: string[]
): Promise<GetHomeSpacesEngagementResponse> => {
  if (!spaceIds.length) {
    return { spaceEngagement: [] };
  }

  const { data, status } = await request<GetHomeSpacesEngagementContract>({
    method: 'get',
    url: HOME_SPACES_ENGAGEMENT(spaceIds),
  });

  if (status !== 200) {
    throw new Error(`Home spaces engagement fetch non 200: ${status}`);
  }

  return data;
};

export default getHomeSpacesEngagement;
